<template>
<v-dialog v-model="show" max-width="600" persistent>
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on" :note_count="sample.notes.length" :notes="sample.notes" :flags="flags"></slot>
  </template>
  <v-card>
    <CardTitle :title="`Notes ${sample.qa}`"></CardTitle>
    <v-card-text>
      <v-menu open-on-hover :close-on-content-click="false">
        <template v-slot:activator="{on}">
          <v-btn color="success" v-on="on">Add Flag</v-btn>
        </template>
        <v-list>
          <v-list-item v-for="flagType in sampleFlagTypes" :key="flagType.uuid" @click="addFlag(flagType)">
            <v-list-item-action v-if="flags.find(({sample_flag_type_uuid}) => flagType.uuid === sample_flag_type_uuid)"><v-icon color="success">mdi-check</v-icon></v-list-item-action>
            <v-list-item-action><v-chip x-small :color="flagType.color" class="mr-2"></v-chip></v-list-item-action>
            {{flagType.name}}
          </v-list-item>
        </v-list>
      </v-menu>
      <v-row dense>
        <v-col v-for="flag in flags" :key="flag.sample_flag_type_uuid">
          <v-chip :color="flag.type.color" dark>{{flag.type.name}} <v-btn class="ml-2" @click="addFlag(flag.type)" x-small icon outlined dark><v-icon small>close</v-icon></v-btn></v-chip>
        </v-col>
      </v-row>
      <v-form ref="form">
        <template v-for="(note, index) in notes">
          <v-row :key="index">
            <v-col>
              <v-autocomplete v-model="note.sample_note_type_uuid" :rules="formRules" :items="sampleNoteTypes" label="Note Type"  item-text="name" item-value="uuid">
                <template v-slot:append-outer>
                  <v-btn @click="notes.splice(index, 1)" color="error" tile outlined><v-icon>remove</v-icon></v-btn>
                </template>
              </v-autocomplete>
              <v-textarea v-model="note.note" :rules="formRules" label="Note"></v-textarea>
            </v-col>
          </v-row>
        </template>
        <v-btn color="success" @click="addNote" block>Add Note</v-btn>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <CardActions @close="close" @submit="save" close_text="Cancel"></CardActions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
    name: "StepSampleCreateNote",
    components: {},
    data: () => ({
      show: false,
      notes: [],
      flags: [],
      formRules: [
          v => !!v || "This field is required."
      ]
    }),
    props:{
      sample: {
        required: true,
      },
      sample_index: {
        required: true,
      }
    },
    computed:{
      sampleNoteTypes(){
        return this.$store.$db().model('sampleNoteTypes').all();
      },
      sampleFlagTypes(){
        let flags = this.$store.$db().model('sampleFlagTypes').query().orderBy("display_index").all();
        let filtered = this.$store.state.manifest_filtered_flags || [];
        if (filtered.length > 0) {
          return flags.filter(flag => !filtered.includes(flag.uuid));
        }
        return flags;
      }
    },
    watch: {
      sample: {
        deep: true,
        handler(v){
         this.setNotes(v.notes);
         this.setFlags(v.sample_flags);
        }
      }
    },
    methods: {
      addFlag(type){
        let findIndex = this.flags.findIndex(flag => flag.sample_flag_type_uuid === type.uuid)
        if(findIndex !== -1){
          this.flags.splice(findIndex, 1);
        }else{
          this.flags.push({
            uuid: null,
            sample_flag_type_uuid: type.uuid,
            created_by: this.$store.getters.id,
            updated_by: this.$store.getters.id,
            type: type,
          })
        }
      },
      addNote(){
        this.notes.push({
          uuid: null,
          note: null,
          sample_note_type_uuid: null,
          created_by: this.$store.getters.id,
          updated_by: this.$store.getters.id,
        })
      },
      setNotes(notes){
        this.notes = notes.map(note => ({...note}));
      },
      setFlags(flags){
        this.flags = flags.map(flag => ({...flag}));
      },
      save(flagsOnly = false){
        this.$emit('set_flags', {
          sample_index: this.sample_index,
          flags: this.flags,
        })
        if(!flagsOnly){
          if(!this.$refs.form.validate()) return;
          this.$emit('set_notes', {
            sample_index: this.sample_index,
            notes: this.notes,
          })
        }
        this.close();
      },
      close(){
        const notes = this.sample.notes;
        const flags = this.sample.sample_flags;
        this.notes = [...notes];
        this.flags = [...flags]
        this.show = false;
      }
    }
}
</script>

<style scoped>

</style>
